const licenses = {
  "version": "0.1.0",
  "name": "shared-data-portal",
  "dependencies": {
    "@azure/msal-browser": {
      "version": "2.38.2",
      "resolved": "https://registry.npmjs.org/@azure/msal-browser/-/msal-browser-2.38.2.tgz",
      "overridden": false
    },
    "@azure/msal-react": {
      "version": "1.5.11",
      "resolved": "https://registry.npmjs.org/@azure/msal-react/-/msal-react-1.5.11.tgz",
      "overridden": false
    },
    "@emotion/react": {
      "version": "11.11.0",
      "resolved": "https://registry.npmjs.org/@emotion/react/-/react-11.11.0.tgz",
      "overridden": false
    },
    "@emotion/styled": {
      "version": "11.11.0",
      "resolved": "https://registry.npmjs.org/@emotion/styled/-/styled-11.11.0.tgz",
      "overridden": false
    },
    "@reduxjs/toolkit": {
      "version": "1.9.5",
      "resolved": "https://registry.npmjs.org/@reduxjs/toolkit/-/toolkit-1.9.5.tgz",
      "overridden": false
    },
    "@szhsin/react-menu": {
      "version": "4.0.1",
      "resolved": "https://registry.npmjs.org/@szhsin/react-menu/-/react-menu-4.0.1.tgz",
      "overridden": false
    },
    "@testing-library/jest-dom": {
      "version": "5.16.5",
      "resolved": "https://registry.npmjs.org/@testing-library/jest-dom/-/jest-dom-5.16.5.tgz",
      "overridden": false
    },
    "@testing-library/react": {
      "version": "13.4.0",
      "resolved": "https://registry.npmjs.org/@testing-library/react/-/react-13.4.0.tgz",
      "overridden": false
    },
    "@testing-library/user-event": {
      "version": "13.5.0",
      "resolved": "https://registry.npmjs.org/@testing-library/user-event/-/user-event-13.5.0.tgz",
      "overridden": false
    },
    "aws-amplify": {
      "version": "5.2.5",
      "resolved": "https://registry.npmjs.org/aws-amplify/-/aws-amplify-5.2.5.tgz",
      "overridden": false
    },
    "aws-sdk": {
      "version": "2.1404.0",
      "resolved": "https://registry.npmjs.org/aws-sdk/-/aws-sdk-2.1404.0.tgz",
      "overridden": false
    },
    "bootstrap": {
      "version": "5.2.3",
      "resolved": "https://registry.npmjs.org/bootstrap/-/bootstrap-5.2.3.tgz",
      "overridden": false
    },
    "react-dom": {
      "version": "18.2.0",
      "resolved": "https://registry.npmjs.org/react-dom/-/react-dom-18.2.0.tgz",
      "overridden": false
    },
    "react-dropdown": {
      "version": "1.11.0",
      "resolved": "https://registry.npmjs.org/react-dropdown/-/react-dropdown-1.11.0.tgz",
      "overridden": false
    },
    "react-helmet": {
      "version": "6.1.0",
      "resolved": "https://registry.npmjs.org/react-helmet/-/react-helmet-6.1.0.tgz",
      "overridden": false
    },
    "react-icons": {
      "version": "4.8.0",
      "resolved": "https://registry.npmjs.org/react-icons/-/react-icons-4.8.0.tgz",
      "overridden": false
    },
    "react-loader-spinner": {
      "version": "5.3.4",
      "resolved": "https://registry.npmjs.org/react-loader-spinner/-/react-loader-spinner-5.3.4.tgz",
      "overridden": false
    },
    "react-redux": {
      "version": "8.0.7",
      "resolved": "https://registry.npmjs.org/react-redux/-/react-redux-8.0.7.tgz",
      "overridden": false
    },
    "react-router-dom": {
      "version": "6.11.1",
      "resolved": "https://registry.npmjs.org/react-router-dom/-/react-router-dom-6.11.1.tgz",
      "overridden": false
    },
    "react-scripts": {
      "version": "5.0.1",
      "resolved": "https://registry.npmjs.org/react-scripts/-/react-scripts-5.0.1.tgz",
      "overridden": false
    },
    "react-select": {
      "version": "5.7.3",
      "resolved": "https://registry.npmjs.org/react-select/-/react-select-5.7.3.tgz",
      "overridden": false
    },
    "react-table": {
      "version": "7.8.0",
      "resolved": "https://registry.npmjs.org/react-table/-/react-table-7.8.0.tgz",
      "overridden": false
    },
    "react": {
      "version": "18.2.0",
      "resolved": "https://registry.npmjs.org/react/-/react-18.2.0.tgz",
      "overridden": false
    },
    "sass": {
      "version": "1.62.1",
      "resolved": "https://registry.npmjs.org/sass/-/sass-1.62.1.tgz",
      "overridden": false
    },
    "styled-components": {
      "version": "6.0.7",
      "resolved": "https://registry.npmjs.org/styled-components/-/styled-components-6.0.7.tgz",
      "overridden": false
    },
    "uuid": {
      "version": "10.0.0",
      "resolved": "https://registry.npmjs.org/uuid/-/uuid-10.0.0.tgz",
      "overridden": false
    },
    "web-vitals": {
      "version": "2.1.4",
      "resolved": "https://registry.npmjs.org/web-vitals/-/web-vitals-2.1.4.tgz",
      "overridden": false
    },
    "xlsx": {
      "version": "0.18.5",
      "resolved": "https://registry.npmjs.org/xlsx/-/xlsx-0.18.5.tgz",
      "overridden": false
    }
  }
}


export default licenses
